import { civilities } from "../../static/types/commonTypes/individualType"
import PostalCodeField from "./PostalCodeField"
import useValidation from "../../hooks/useValidation"
import { useEffect } from "react"
import headOfficeAddressValidationSchema from "../../utils/validation/headOfficeValidationSchema"
import { getCityWithPreposition } from "../../utils/functions/getCityWithPreposition"
import { NotaryContactType } from "../../static/types/commonTypes/notaryContactType"
import { notaryContactValidationSchema } from "../../utils/validation/notaryContactValidationSchema"

type NotaryContactProps = {
    checked: boolean,
    notaryContact: NotaryContactType,
    changeNotaryContact: ( notaryContact: Partial<NotaryContactType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function NotaryContact ({
    checked,
    notaryContact,
    changeNotaryContact,
    onValidationChange
}: NotaryContactProps ) {

    const { errors, isValid } = useValidation( notaryContact, notaryContactValidationSchema )

    useEffect( () => {
        onValidationChange( isValid )
    }, [ isValid, onValidationChange ])

    return(
        <div className = "mb-3 row">
            
            <div className = "mb-3 row">
                <label htmlFor = "notaryName" className = "col-sm-4 col-form-label">Nom du notaire <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-6">

                    <input
                        className = { `form-control ${ ( checked && errors.notaryName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "notaryName"
                        id = "notaryName"
                        value = { notaryContact.notaryName }
                        onChange = { event => changeNotaryContact({ notaryName: event.target.value }) }
                    />
                    {  ( checked && errors.notaryName ) && <div className="invalid-feedback"> { errors.notaryName } </div> }

                </div>
            </div>

            <div className = "mb-3 row">
                <label htmlFor = "scpName" className = "col-sm-4 col-form-label">Nom de la SCP <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-6">

                    <input
                        className = { `form-control ${ ( checked && errors.scpName ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "scpName"
                        id = "scpName"
                        value = { notaryContact.scpName }
                        onChange = { event => changeNotaryContact({ scpName: event.target.value }) }
                    />
                    {  ( checked && errors.scpName ) && <div className="invalid-feedback"> { errors.scpName } </div> }

                </div>
            </div>


            <div className = "mb-3 row">
                <label htmlFor = "address" className = "col-sm-4 col-form-label">Adresse <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-6">

                    <input
                        className = { `form-control ${ ( checked && errors.address ) ? 'is-invalid' : ''}` }
                        type = "text"
                        name = "address"
                        id = "address"
                        value = { notaryContact.address }
                        onChange = { event => changeNotaryContact({ address: event.target.value }) }
                    />
                    {  ( checked && errors.address ) && <div className="invalid-feedback"> { errors.address } </div> }

                </div>
            </div>

            <div className = "mb-3 row">
                <label htmlFor = "additionalAddress" className = "col-sm-4 col-form-label">Adresse suite</label>
                
                <div className = "col-sm-6">
                    <input
                        className = "form-control"
                        type = "text"
                        name = "additionalAddress"
                        value = { notaryContact.additionalAddress }
                        onChange = { event => changeNotaryContact({ additionalAddress: event.target.value })}
                    />
                </div>
            </div>

            <div className = "mb-3 row">

                <PostalCodeField
                    checked = { checked }
                    onChange = { changeNotaryContact }
                    postalCode = { notaryContact.postalCode }
                    errors = { errors }
                />

                <label htmlFor = "city" className = "col-sm-2 col-form-label">Ville <strong className="text-danger">*</strong> </label>

                <div className = "col-sm-4">

                    <select
                        className = { `form-control ${ ( checked && errors.city ) ? 'is-invalid' : ''}` }
                        name = "city"
                        id = "city"
                        onChange = { event => changeNotaryContact({ city: event.target.value }) }
                    >
                        {
                            notaryContact.cities?.map( ( city, key )  => 
                                <option key = { key } value = { city }>
                                    { city }
                                </option>
                            )
                        }
                    </select>
                    {  ( checked && errors.city ) && <div className="invalid-feedback"> { errors.city } </div> }

                </div>
            </div>

        </div>
    )
}